import * as TabsPrimitive from '@radix-ui/react-tabs';
import React from 'react';
import { cn } from '../utils/cn';

const TabsList = React.forwardRef<
    React.ElementRef<typeof TabsPrimitive.List>,
    React.ComponentPropsWithoutRef<typeof TabsPrimitive.List>
>(({ className, ...props }, ref) => (
    <TabsPrimitive.List ref={ref} className={cn('inline-flex h-9 items-center justify-center', className)} {...props} />
));
TabsList.displayName = TabsPrimitive.List.displayName;

const TabsTrigger = React.forwardRef<
    React.ElementRef<typeof TabsPrimitive.Trigger>,
    React.ComponentPropsWithoutRef<typeof TabsPrimitive.Trigger>
>(({ className, ...props }, ref) => (
    <TabsPrimitive.Trigger
        ref={ref}
        className={cn(
            'font-copy-sm-strong border-light-gray focus-visible:outline-blue data-[state=active]:border-red inline-flex items-center justify-center whitespace-nowrap border-b-2 p-4 focus-visible:outline-2 disabled:pointer-events-none disabled:opacity-50 data-[state=active]:border-b-2',
            className
        )}
        {...props}
    />
));
TabsTrigger.displayName = TabsPrimitive.Trigger.displayName;

export const Tabs = {
    Root: TabsPrimitive.Root,
    List: TabsList,
    Trigger: TabsTrigger,
};
